<div class="mb-3 row">
	<!-- <label for="search-indications" class="col-xs-3 col-sm-auto col-form-label" style="color: #dee2e6">Search Indications:</label> -->
	<div [ngClass]="{'col-12': !model, 'col-10': model}">
		<input
			id="search-indications"
			type="text"
			class="form-control"
			[(ngModel)]="model"
			[ngbTypeahead]="search"
			[inputFormatter]="formatter"
			[resultFormatter]="formatter"
			[editable]="false"
			[placeholder]="'Indication Search - Start typing an indication name or keyword...'"
			(selectItem)="indicationSelected($event)"
			(click)="clearSearch()"
		/>
	</div>
	<div *ngIf="model" class="col-2">
		<button style="width: 100%;" kendoButton id="clearSearchIndicationButton" (click)="clearSearch()" fillMode="outline">Clear Search</button>
	</div>
</div>